import { DealersAndLocationsDropdownKeys } from "components/DealersAndLocationsDropdown/queryKeys";
import { useTypedQuery } from "hooks";
import { ApiInstance } from "utils/Api";

import type { DealersListResp } from "components/DealersAndLocationsDropdown/queryKeys";

const getHoldingLocations = (allDealers: DealersListResp) => (allDealers.holding_dealers ?? []).flatMap(dealer => dealer.locations || []);

export const usePermanentHoldingLocations = () => {
  return {
    holdingLocations:
      useTypedQuery({
        queryKey: DealersAndLocationsDropdownKeys.dealers,
        queryFn: async ({ endpoint, params, baseUrl }) => (await ApiInstance.post(endpoint, params, baseUrl)).data,
        select: getHoldingLocations
      }).data || []
  };
};
